import Vue from "vue";
import {
  Avatar,
  Button,
  Card,
  Carousel,
  CarouselItem,
  Col,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Image,
  Message,
  Pagination,
  Row
} from "element-ui";
// import "@/assets/css/element-variables.scss";

Vue.use(Avatar);
Vue.use(Button);
Vue.use(Card);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Image);
Vue.use(Pagination);
Vue.use(Row);

Vue.prototype.$message = Message;
